import { defineContainer } from './vue-component-lib/utils';
import { defineCustomElements } from '@ui-kit/stencil-library/loader';
defineCustomElements();
export const FbcAccordion = defineContainer('fbc-accordion', undefined, [
    'items',
    'multipleExpand'
]);
export const FbcBackstageShortcutsLinks = defineContainer('fbc-backstage-shortcuts-links', undefined, [
    'titleCard',
    'tools',
    'dataTestId'
]);
export const FbcBadge = defineContainer('fbc-badge', undefined, [
    'variant',
    'color',
    'defaultType',
    'isStickerRounded',
    'label',
    'value',
    'dataTestId'
]);
export const FbcButton = defineContainer('fbc-button', undefined, [
    'color',
    'variant',
    'size',
    'class',
    'disabled',
    'fullWidth',
    'icon',
    'iconSize',
    'iconColor',
    'iconFillColor',
    'loading',
    'underline',
    'dataTestId'
]);
export const FbcCard = defineContainer('fbc-card', undefined, [
    'altMedia',
    'contentText',
    'header',
    'iconHeader',
    'iconInHeader',
    'media',
    'subHeader',
    'subTitleBody',
    'thumbnail',
    'titleBody',
    'type',
    'variant',
    'withActions',
    'actions',
    'actionButtonsWidth',
    'alignAction',
    'labelPrimaryAction',
    'variantPrimaryAction',
    'primaryActionDataTestId',
    'labelSecondaryAction',
    'variantSecondaryAction',
    'secondaryActionDataTestId',
    'handle-click-header',
    'handle-primary-action',
    'handle-secondary-action'
]);
export const FbcCellGrid = defineContainer('fbc-cell-grid', undefined, [
    'size',
    'xs',
    'sm',
    'md',
    'class'
]);
export const FbcCheckbox = defineContainer('fbc-checkbox', undefined, [
    'disabled',
    'indeterminate',
    'label',
    'labelPlacement',
    'name',
    'required',
    'checked',
    'value-change'
]);
export const FbcChip = defineContainer('fbc-chip', undefined, [
    'color',
    'variant',
    'type',
    'alwaysFocusable',
    'disabled',
    'label',
    'href',
    'target',
    'icon',
    'dataTestId'
]);
export const FbcCircularProgress = defineContainer('fbc-circular-progress', undefined, [
    'indeterminate',
    'max',
    'size',
    'value'
]);
export const FbcIcon = defineContainer('fbc-icon', undefined, [
    'icon',
    'iconBoxClass',
    'iconColor',
    'iconFillColor',
    'size'
]);
export const FbcIconButton = defineContainer('fbc-icon-button', undefined, [
    'disabled',
    'href',
    'icon',
    'iconSize',
    'target',
    'variant',
    'iconColor',
    'iconFillColor'
]);
export const FbcInput = defineContainer('fbc-input', undefined, [
    'color',
    'variant',
    'type',
    'class',
    'disabled',
    'error',
    'errorText',
    'fullWidth',
    'helperText',
    'label',
    'placeholder',
    'prefixText',
    'suffixText',
    'readOnly',
    'required',
    'rows',
    'cols',
    'max',
    'maxLength',
    'min',
    'minLength',
    'pattern',
    'step',
    'leadingIcon',
    'leadingIconIsClickable',
    'leadingIconColor',
    'leadingIconFillColor',
    'leadingIconSize',
    'trailingIcon',
    'trailingIconIsClickable',
    'trailingIconColor',
    'trailingIconFillColor',
    'trailingIconSize',
    'value',
    'value-change',
    'leading-icon-on-click',
    'trailing-icon-on-click'
]);
export const FbcLayoutCard = defineContainer('fbc-layout-card', undefined, [
    'srcImage',
    'label',
    'redirectPath',
    'dataTestId',
    'handle-link-action'
]);
export const FbcLayoutGrid = defineContainer('fbc-layout-grid', undefined, [
    'gap'
]);
export const FbcLinearProgress = defineContainer('fbc-linear-progress', undefined, [
    'buffer',
    'fullWidth',
    'indeterminate',
    'max',
    'value'
]);
export const FbcLogo = defineContainer('fbc-logo', undefined, [
    'color'
]);
export const FbcMenu = defineContainer('fbc-menu', undefined, [
    'labelEmptyOptions',
    'optionLabel',
    'optionValue',
    'density',
    'open',
    'options',
    'dataTestId',
    'handle-close',
    'menu-selected'
]);
export const FbcModal = defineContainer('fbc-modal', undefined, [
    'type',
    'size',
    'open',
    'headline',
    'subtitle',
    'altMedia',
    'media',
    'contentTitle',
    'contentSubtitle',
    'contentText',
    'withActions',
    'actions',
    'actionButtonsWidth',
    'alignAction',
    'labelPrimaryAction',
    'variantPrimaryAction',
    'primaryActionDataTestId',
    'labelSecondaryAction',
    'variantSecondaryAction',
    'secondaryActionDataTestId',
    'dataTestId',
    'handle-close',
    'handle-primary-action',
    'handle-secondary-action'
]);
export const FbcRadio = defineContainer('fbc-radio', undefined, [
    'label',
    'labelPlacement',
    'name',
    'checked',
    'disabled',
    'required',
    'value',
    'value-change'
]);
export const FbcSearch = defineContainer('fbc-search', undefined, [
    'disabled',
    'error',
    'errorText',
    'fullWidth',
    'helperText',
    'label',
    'optionLabel',
    'optionValue',
    'placeholder',
    'required',
    'labelNotSuggestions',
    'value',
    'suggestions',
    'value-change'
]);
export const FbcSelect = defineContainer('fbc-select', undefined, [
    'variant',
    'class',
    'disabled',
    'error',
    'errorText',
    'fullWidth',
    'helperText',
    'label',
    'optionLabel',
    'optionValue',
    'required',
    'options',
    'value',
    'value-change'
]);
export const FbcSidebar = defineContainer('fbc-sidebar', undefined, [
    'dataTestId',
    'welcomeMessage',
    'username',
    'optionLabel',
    'optionValue',
    'emptyCompaniesLabel',
    'companies',
    'value',
    'activeLink',
    'mainLinks',
    'productLinks',
    'configLinks',
    'isSidebarCollapsed',
    'value-change',
    'handle-open-action',
    'handle-link-action'
]);
export const FbcSidebarLayout = defineContainer('fbc-sidebar-layout', undefined, [
    'dataTestId',
    'welcomeMessage',
    'username',
    'optionLabel',
    'optionValue',
    'emptyCompaniesLabel',
    'companies',
    'value',
    'mainLinks',
    'productLinks',
    'configLinks',
    'isSidebarCollapsed',
    'value-change',
    'handle-open-action',
    'handle-link-action'
]);
export const FbcSidebarLink = defineContainer('fbc-sidebar-link', undefined, [
    'disabled',
    'divider',
    'icon',
    'image',
    'iconColor',
    'iconFillColor',
    'isOpenDrawer',
    'label',
    'redirectPath',
    'size',
    'target',
    'activeLink',
    'multipleLinks',
    'optionLinkLabel',
    'optionLinkPath',
    'links',
    'dataTestId',
    'handle-link-action'
]);
export const FbcSlider = defineContainer('fbc-slider', undefined, [
    'disabled',
    'fullWidth',
    'labeled',
    'max',
    'min',
    'range',
    'step',
    'ticks',
    'value',
    'valueEnd',
    'valueLabel',
    'valueLabelEnd',
    'valueLabelStart',
    'valueStart',
    'value-change'
]);
export const FbcSnackbar = defineContainer('fbc-snackbar', undefined, [
    'autoHideDuration',
    'closeAction',
    'customButtonAction',
    'customButtonLabel',
    'message',
    'position',
    'variant',
    'open',
    'handle-click-custom-action',
    'handle-close'
]);
export const FbcSwitch = defineContainer('fbc-switch', undefined, [
    'disabled',
    'icons',
    'label',
    'labelPlacement',
    'name',
    'required',
    'showOnlySelectedIcon',
    'selected',
    'value',
    'value-change'
]);
export const FbcSymbolLogo = defineContainer('fbc-symbol-logo', undefined);
export const FbcTable = defineContainer('fbc-table', undefined, [
    'data',
    'columns',
    'selectable',
    'dataToSelect',
    'handle-row-selected'
]);
export const FbcTabs = defineContainer('fbc-tabs', undefined, [
    'autoActivate',
    'fullWidth',
    'tabsAriaLabel',
    'activateTabIndex',
    'tabs',
    'tabHasIcon',
    'tabIcon',
    'tabIconOnly',
    'tabIconSize',
    'tabInlineIcon',
    'type',
    'handle-active-tab'
]);
export const FbcTooltip = defineContainer('fbc-tooltip', undefined, [
    'disabled',
    'text',
    'textTile',
    'type',
    'withActions'
]);
export const MyComponent = defineContainer('my-component', undefined, [
    'first',
    'middle',
    'last'
]);
//# sourceMappingURL=components.js.map